import hasDom from 'has-dom';
import { Pixall, Google, Segment } from '../analytics/index.js';
import { transformCoxAutoDataLayer, getInventoryOwnerById } from '../utilities/index.js';
import { listingTypeUtils } from '../transformers/pixall/index.js';
const getCDLByPageType = (pageType, dataLayer) => {
  let valueEventCode;
  if (dataLayer.page?.pg === 'fyc_vdp' && dataLayer.vehicle?.owner?.privateSeller) {
    valueEventCode = 'V23H';
  } else if (dataLayer.page?.pg === 'fyc_hybrid_vdp') {
    valueEventCode = 'R2D2';
  } else {
    valueEventCode = '07C4';
  }
  if (pageType === 'vdp') {
    return {
      eventProperties: {
        event: {
          valueEventCode
        }
      }
    };
  }
  if (pageType === 'dealer-ratings') {
    return {
      eventProperties: {
        peSnapshotId: dataLayer.peSnapshotId,
        consumerInsights: dataLayer.consumerInsights,
        consumerAdTargets: dataLayer.consumerAdTargets,
        consumerAdTargetsWithoutCAMPBias: dataLayer.consumerAdTargetsWithoutCAMPBias,
        consumerCampaignPreferences: dataLayer.consumerCampaignPreferences,
        consumerMarketingSegments: dataLayer.consumerMarketingSegments
      }
    };
  }
  return {};
};

/**
 * @summary Sends Pixall|Google|Segment page events
 */
export async function page(metadata, options) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    data = {},
    dataIsland,
    dataLayer = {},
    state,
    filterDuck,
    // optional
    queryDuck,
    // optional
    history
  } = metadata;
  const filterValues = filterDuck ? filterDuck.selectors.getRequestValues(state) : {};
  const {
    inventoryId,
    statusCode
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const isPSXVDP = dataLayer.page?.pg === 'fyc_vdp' && dataLayer.vehicle?.owner?.privateSeller;
  const isBuildAndPrice = dataLayer.page?.pg === 'bld_and_pr';
  const isError = dataLayer.page?.pg === 'error';
  const isDDP = dataLayer.page?.pageName === 'ddp';
  if (isPSXVDP) {
    dataLayer.page.detailPageName = 'psx_vdp';
    dataLayer.vehicle.clickType = 'pvt';
  }
  if (isBuildAndPrice) {
    dataLayer.page.pageType = 'build_price';
    dataLayer.page.detailPageName = 'build_price';
  }
  const pageId = dataLayer?.page?.pg;
  if (pageId === 'fyc_lnd_fba') {
    dataLayer.page.pageType = 'slp_fba';
    dataLayer.page.detailPageName = 'slp_fba';
  }
  let listingType = 'lstg';
  if (pageId === 'fyc_vdp') {
    const queryValues = queryDuck?.selectors?.getDuckState(state) || {};
    const {
      clickType,
      makeCode,
      modelCode,
      vehicleHistoryType,
      homeServices
    } = queryValues;
    listingType = listingTypeUtils.convertClickTypeToListingType(clickType);

    // update search filters for pageload
    dataLayer.search.filters = {
      ...dataLayer?.search?.filters,
      makeCode,
      modelCode,
      vehicleHistoryType,
      homeServices
    };
  }

  // remove searchFacetMaxYear (syx) fire in FLD-DDP
  if (isDDP) {
    delete filterValues.endYear;
  }
  const dataWithFilters = {
    ...data,
    zipCode: dataLayer?.user?.zipCode ?? '',
    filterValues: {
      ...filterValues
    },
    ...(isPSXVDP && {
      pageType: 'vdp',
      label: 'fyc_psx_vdp',
      pageId: 'fyc_psx_vdp'
    }),
    ...(isBuildAndPrice && hasDom() && document?.title && {
      title: document.title
    })
  };
  if (isError) {
    dataLayer.page.siteSection = 'error';
    dataLayer.page.pageType = 'error';
    dataLayer.page.detailPageName = `error_${statusCode}`;
    dataWithFilters.pageName = `error${statusCode}`;
  }

  // Set the page type for other places to use
  if (data?.pageType) {
    dataIsland.page.pixallPageType = data?.pageType;
  }
  const cdl = getCDLByPageType(data.pageType, dataLayer);
  transformCoxAutoDataLayer({
    listingType,
    cdl,
    dataLayer,
    eventType: 'page'
  });
  const pageEvents = [Pixall.sendPageEvent({
    ...dataWithFilters,
    inventory,
    ...{
      cdl
    }
  }, {
    dataLayer,
    history
  }, options), Google.sendPageDataEvent(metadata, options)];

  // Segment Page Events are only to be fired on PSX VDPs
  if (isPSXVDP) {
    pageEvents.push(Segment.sendPageEvent(metadata, options));
  }
  await Promise.all(pageEvents);
  return {};
}

/**
 * @deprecated
 * TODO: Remove this after FYC and FYD remove the event
 */
export function search() {
  return {};
}
export default {
  page,
  search
};